import { render } from "./Layout.vue?vue&type=template&id=37e7dd67"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"

import "./Layout.vue?vue&type=style&index=0&id=37e7dd67&lang=css"

import exportComponent from "/codebuild/output/src2038848539/src/admin-wallet-v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__